
import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useSoundNotification } from './useSoundNotification';
import { useToast } from '@/hooks/use-toast';

export const useBusinessSoundNotification = (restaurantId: string) => {
  const { playNotificationSound, initializeAudio } = useSoundNotification();
  const { toast } = useToast();

  useEffect(() => {
    if (!restaurantId) return;

    // Initialize audio
    initializeAudio();

    const channel = supabase
      .channel('business-notifications')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'orders',
          filter: `restaurant_id=eq.${restaurantId}`
        },
        (payload) => {
          console.log('New order notification:', payload);
          
          if (payload.new.status === 'pending' || payload.new.status === 'waiting_for_payment') {
            console.log('Playing sound for new order...');
            playNotificationSound();
            
            toast({
              title: "New Order Received!",
              description: `Order #${payload.new.id.slice(0, 8)} - ${payload.new.customer_name || 'Customer'}`,
            });
          }
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'orders',
          filter: `restaurant_id=eq.${restaurantId}`
        },
        (payload) => {
          // Play sound when order status changes to waiting_for_payment
          if (payload.new.status === 'waiting_for_payment' && payload.old.status !== 'waiting_for_payment') {
            console.log('Order now waiting for payment, playing sound...');
            playNotificationSound();
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [restaurantId, playNotificationSound, initializeAudio, toast]);
};
